<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 126.46 119.22"
    width="24px"
    height="24px"
    class="svg-icon"
  >
    <path
      d="M124.08,29.57,98.61,4.09a10.77,10.77,0,0,0-15.19,0L3.92,83.6a10.73,10.73,0,0,0,0,15.19l13.14,13.14a28.21,28.21,0,0,0,39.85,0l67.17-67.18a10.72,10.72,0,0,0,0-15.18Zm-72.83,76.7a20.19,20.19,0,0,1-28.53,0L9.57,93.13a2.74,2.74,0,0,1,0-3.87l27-27L65.93,91.6Z"
      transform="translate(-0.77 -0.95)"
    />
  </svg>
</template>

<script>
export default {
  name: "icon-erase"
};
</script>

<style scoped></style>
